export default "__VITE_PUBLIC_ASSET__f259f4c6__"